import { render, staticRenderFns } from "./KC_SettingsWindow.vue?vue&type=template&id=39425ab4&scoped=true"
import script from "./KC_SettingsWindow.vue?vue&type=script&lang=js"
export * from "./KC_SettingsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39425ab4",
  null
  
)

export default component.exports